import React, { useState, useEffect } from 'react'
import api from '../components/api'
import InputMask from 'react-input-mask'
import ModalEmailConfirmacao from '../modals/emailConfirmacaoEvento'

const Modal = (props) => {

    
    var inscricao_id = props.inscricao_id
    var cpf = props.cpf
    var tipo = props.tipo

    var [tipoEmail, setTipoEmail] = useState('')

    var [nomeParticipante, setNomeParticipante] = useState('')
    var [dataInscricao, setDataInscricao] = useState()
    var [confirmado, setConfirmado] = useState(false)
    var [presente, setPresente] = useState(false)
    var [participacoes, setParticipacoes] = useState(0)
    var [inscricoes, setInscricoes] = useState(0) 

    var [evento_id, setEvento_id] = useState()

    var [bairro, setBairro] = useState('')
    var [cargo, setCargo] = useState('')
    var [cep, setCEP] = useState('')
    var [data_nascimento, setDataNascimento] = useState('')
    var [email, setEmail] = useState('')
    var [endereco, setEndereco] = useState('')
    var [municipio, setMunicipio] = useState('')
    var [nome_organizacao, setNomeOrganizacao] = useState('')
    var [numero, setNumero] = useState('')
    var [outro_pais, setOutroPais] = useState('')
    var [sexo, setSexo] = useState('')
    var [telefone_comercial, setTelefoneComercial] = useState('')
    var [telefone_residencial, setTelefoneResidencial] = useState('')
    var [uf_codigo, setUfCodigo] = useState('')

    
    async function carrega() {

        if (inscricao_id) {

            await api.get(`inscrito/${inscricao_id}`).then((result) => {

                //console.log(result.data)

                var data = result.data[0]

                if (data) {

                    setNomeParticipante(data.nomeParticipante)
                    setDataInscricao(data.data_inscricao)
                    setConfirmado(data.confirmado == null ? false : data.confirmado)
                    setPresente(data.presente == null ? false : data.presente)
                    setParticipacoes(data.participacoes)
                    setInscricoes(data.inscricoes)
                    setEvento_id(data.evento_id)
                    setCargo(data.cargo)
                    setBairro(data.bairro)
                    setCargo(data.cargo)
                    setCEP(data.cep)
                    setDataNascimento(data.data_nascimento)
                    setEmail(data.email)
                    setEndereco(data.endereco)
                    setMunicipio(data.municipio)
                    setNomeOrganizacao(data.nome_organizacao)
                    setNumero(data.numero)
                    setOutroPais(data.outro_pais)
                    setSexo(data.sexo)
                    setTelefoneComercial(data.telefone_comercial)
                    setTelefoneResidencial(data.telefone_residencial)
                    setUfCodigo(data.uf_codigo)
                    
                }
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }

        


    }


    const apagaInscricao = () => {





        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar essa inscrição?',
		    buttons: {
		        Sim: function () {


                    api.delete(`inscrito/${inscricao_id}`).then((result) => {

                        console.log(result.data)
                        window.$("#modalInscritoEvento").modal('hide');
                        props.carregaEvento()
                        props.inscritos()
                        

                    }).catch((err) => {

                        console.log(err.response)

                    })


                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }


    function geraCertificado() {


        api.get(`eventoCertificado/${evento_id}/${cpf.replaceAll('.', '').replaceAll('-','')}`).then((result) => {

            //console.log(result.data)

            if (result.data.arquivo) {

                //window.open(`http://172.16.1.253:3600/pdf/${result.data.arquivo}`)
                window.location.href = `https://cdn.hospitaissaudaveis.org/pdf/${result.data.arquivo}`

            } else {

                window.toastr.error('Certificado não encontrado!')

            }
            
        }).catch((err) => {

            console.log(err.response)

        })



    }

    function salvar() {


        var dataPost = {

            presente: presente,
            confirmado: confirmado,

        }

        //console.log(dataPost)

        api.put(`inscrito/${inscricao_id}`, dataPost).then((result) => {

            
            if (result.data.alerta == 'ok') {

                window.$("#modalInscritoEvento").modal('hide');
                props.inscritos()
                //window.toastr.success('Salvo com sucesso!')
                //props.alteraTexto(`presente${inscricao_id}`, confirmado == true ? 'Sim' : 'Não')

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {


        carrega()


    }, [inscricao_id])


    return (

        <div>


                <div className="modal fade" id="modalInscritoEvento" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Detalhe inscrito</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">
                                        
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Inscrito</label>
                                                <input type="text" class="form-control" placeholder="" value={nomeParticipante} readOnly />
                                                                
                                            </div>
                                        </div>


                                        <div className="col-md-12" >
                                            <div class="form-group" >
                                                <label className="control-label">E-mail:</label>
                                                <input class="form-control" value={email} onChange={event => setEmail(event.target.value)} style={{ 'text-transform': 'lowercase'}} readOnly />
                                                    
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <label className="control-label">Data de nascimento: </label>
                                                <input type="text" class="form-control" value={data_nascimento}  onChange={event => setDataNascimento(event.target.value)} readOnly />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <label className="control-label">Sexo: *</label>
                                                <select class="form-control" onChange={event => setSexo(event.target.value)} value={sexo} readOnly>
                                                    <option value="">[Selecione]</option>
                                                    <option value="M">Masculino</option>
                                                    <option value="F">Feminino</option>
                                                </select>
                                                    
                                            </div>
                                        </div>

                                        <div className="col-md-12" >
                                            <div class="form-group" >
                                                <label className="control-label">Nome organização: </label>
                                                <input type="text" class="form-control" value={nome_organizacao}  readOnly />
                                                    
                                            </div>
                                        </div>

                                        <div className="col-md-12" >
                                            <div class="form-group" >
                                                <label className="control-label">Cargo: </label>
                                                <input type="text" class="form-control" value={cargo}  readOnly />
                                                    
                                            </div>
                                        </div>

                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <label className="control-label">Telefone comercial: </label>
                                                <input type="text" class="form-control" value={telefone_comercial}  onChange={event => setTelefoneComercial(event.target.value)} readOnly />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <label className="control-label">Telefone celular ou residencial: </label>
                                                <input type="text" class="form-control" value={telefone_residencial}  onChange={event => setTelefoneResidencial(event.target.value)} readOnly />
                                                    
                                            </div>
                                        </div>

                                        <div className="col-md-3" style={{ display: 'none'}}>
                                            <div class="form-group" >
                                                <label className="control-label">CEP: </label>
                                                <InputMask mask="99999-999" type="text" class="form-control" value={cep}  onChange={event => setCEP(event.target.value)} readOnly />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-9"  style={{ display: 'none'}}>
                                            <div class="form-group" >
                                                <label className="control-label">Endereço: </label>
                                                <input type="text" class="form-control" value={endereco}  onChange={event => setEndereco(event.target.value)} readOnly />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-8"  style={{ display: 'none'}}>
                                            <div class="form-group" >
                                                <label className="control-label">Bairro: </label>
                                                <input type="text" class="form-control" value={bairro}  onChange={event => setBairro(event.target.value)} readOnly />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4"  style={{ display: 'none'}}>
                                            <div class="form-group" >
                                                <label className="control-label">Número: </label>
                                                <input type="text" class="form-control" value={numero}  onChange={event => setNumero(event.target.value)} readOnly />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-9" >
                                            <div class="form-group" >
                                                <label className="control-label">Município: </label>
                                                <input type="text" class="form-control" value={municipio}  onChange={event => setMunicipio(event.target.value)} readOnly />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-3" >
                                            <div class="form-group" >
                                                <label className="control-label">UF: </label>
                                                <input type="text" class="form-control" value={uf_codigo}  onChange={event => setUfCodigo(event.target.value)} readOnly />
                                                    
                                            </div>
                                        </div>



                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Inscrição em</label>
                                                <input type="text" class="form-control" placeholder="" value={dataInscricao} style={{ backgroundColor: '#cafaf4'}} readOnly />
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label>Inscrições em eventos</label>
                                                <input type="text" class="form-control" placeholder="" value={inscricoes} style={{ backgroundColor: '#cafaf4'}} readOnly />
                                                                
                                            </div>
                                        </div>


                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Confirmado</label>
                                                <select type="text" class="form-control" value={confirmado} onChange={event => setConfirmado(event.target.value)} style={{ backgroundColor: '#cafacc'}}>

                                                    <option value={false}>Não</option>
                                                    <option value={true}>Sim</option>

                                                </select>
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Presente</label>
                                                <select type="text" class="form-control" value={presente}  onChange={event => setPresente(event.target.value)} style={{ backgroundColor: '#cafacc'}}>

                                                    <option value={false}>Não</option>
                                                    <option value={true}>Sim</option>

                                                </select>
                                                                
                                            </div>
                                        </div>



                                    </div>


                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-danger"  style={{cursor: 'pointer'}}onClick={() => apagaInscricao()} >Apagar inscrição</button>
                                <button type="button" className="btn btn-warning" data-toggle="modal" style={{cursor: 'pointer'}} data-target="#ModalEmailConfirmacao" onClick={() => setTipoEmail('C')} >E-mail confirmação</button>
                                <button type="button" className="btn btn-info" data-toggle="modal" style={{cursor: 'pointer'}} data-target="#ModalEmailConfirmacao" onClick={() => setTipoEmail('L')} >E-mail acesso evento</button>
                                <button type="button" className="btn btn-primary" onClick={() => geraCertificado()}>Gerar certificado</button>
                                <button type="button" className="btn btn-success" onClick={() => salvar()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


                <ModalEmailConfirmacao inscricao_id={inscricao_id} tipo={tipo} inscritos={props.inscritos} tipoEmail={tipoEmail} />

        </div>


    )



}


    

export default Modal